const Constants = {
    canvasAspectRatio: 1,
    minDesktopSize: 800,
    drawingShareSize: 1024,
}

export default Constants